var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3,
    className: "fill"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 11.32C10.424 10.848 9.84 10.36 9.84 9.6C9.84 8.728 10.648 8.12 12 8.12C13.136 8.12 13.704 8.552 13.912 9.24C14.008 9.56 14.272 9.8 14.608 9.8H14.848C15.376 9.8 15.752 9.28 15.568 8.784C15.232 7.84 14.448 7.056 13.2 6.752V6.2C13.2 5.536 12.664 5 12 5C11.336 5 10.8 5.536 10.8 6.2V6.728C9.248 7.064 8 8.072 8 9.616C8 11.464 9.528 12.384 11.76 12.92C13.76 13.4 14.16 14.104 14.16 14.848C14.16 15.4 13.768 16.28 12 16.28C10.68 16.28 10 15.808 9.736 15.136C9.616 14.824 9.344 14.6 9.016 14.6H8.792C8.256 14.6 7.88 15.144 8.08 15.64C8.536 16.752 9.6 17.408 10.8 17.664V18.2C10.8 18.864 11.336 19.4 12 19.4C12.664 19.4 13.2 18.864 13.2 18.2V17.68C14.76 17.384 16 16.48 16 14.84C16 12.568 14.056 11.792 12.24 11.32Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.c8a23639.svg";
export { ForwardRef as ReactComponent };